import { GridColumnDimensions, GridSortModel } from '@mui/x-data-grid-premium'

export const defaultSortModel: GridSortModel = [{ field: 'createdTime', sort: 'asc' }]
export const defaultStatusFilter = {
  id: 'not-done-status-filter',
  field: 'masterStatus',
  operator: 'isAnyOf',
  value: ['Not Started', 'In Progress', 'On Hold', 'Need More Info'],
}
export const filter_model_projects = { items: [defaultStatusFilter], quickFilterValues: [] }
export const defaultVisibilityModel = {
  MIA: false,
  QA: false,
  creativeLead: false,
  PM: false,
  dueDate: false,
  isMarketing: false,
  isCreative: false,
  isWebsite: false,
  queueRole: false,
  sendReview: false,
  mode: false,
  isPostdated: false,
  details: false,
  __tree_data_group__: false,
  website: false,
  websiteType: false,
  website_content: false,
  website_domain_access: false,
  website_existing_domain: false,
  website_new_domain: false,
  website_new_domain_input: false,
  website_ssl_cert: false,
  createdTime: false,
  taskDays: false,
  startDate: false,
  taskType: false,
  type: false,
}
export const defaultWidths = {
  orgId: 160,
  contractedBy: 140,
  name: 240,
  commentCount: 75,
  progressSummary: 75,
  masterStatus: 110,
  taskDays: 90,
  highPrio: 90,
  type: 120,
  startDate: 110,
  endDate: 90,
  assigner: 120,
  assignees: 140,
  queue: 120,
  queueRole: 75,
  createdTime: 90,
  sendReview: 90,
  mode: 80,
  isMarketing: 90,
  isCreative: 90,
  isWebsite: 90,
  website: 110,
  websiteType: 110,
  website_content: 120,
  website_domain_access: 130,
  website_existing_domain: 130,
  website_new_domain: 130,
  website_new_domain_input: 140,
  website_ssl_cert: 120,
} as GridColumnDimensions
export const defaultColumnOrder: string[] = [
  'name',
  'contractedBy',
  'orgId',
  'details',
  'isPostdated',
  'commentCount',
  'progressSummary',
  'masterStatus',
  'taskDays',
  'highPrio',
  'type',
  'startDate',
  'endDate',
  'assigner',
  'assigneeNames',
  'assignees',
  'queue',
  'queueRole',
  'createdTime',
  'isMarketing',
  'isCreative',
  'isWebsite',
  'website',
  'websiteType',
  'website_content',
  'website_domain_access',
  'website_existing_domain',
  'website_new_domain',
  'website_new_domain_input',
  'website_ssl_cert',
]
